'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _lodashCompat = require('lodash-compat');

var _lodashCompat2 = _interopRequireDefault(_lodashCompat);

var _reactDom = require('react-dom');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _index = require('../index');

var _zh_CN = require('./locale/zh_CN');

var _zh_CN2 = _interopRequireDefault(_zh_CN);

var _Helper = require('./Helper');

var _data = require('../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var MODEL = {
  idField: "id", // 主键
  nameField: "name", // 名称
  urlField: "url", // 链接
  timeField: "attachTs", // 上传时间
  oprField: "owner" };

var Upload = (_temp = _class = function (_Component) {
  _inherits(Upload, _Component);

  function Upload(props) {
    _classCallCheck(this, Upload);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Upload).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      files: _lodashCompat2.default.cloneDeep(props.value) || [],
      valid: true,
      model: Object.assign({}, MODEL, props.model || {}),
      locale: Object.assign({}, _zh_CN2.default, props.locale || {})
    };
    return _this;
  }

  _createClass(Upload, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props;
      var disabled = _props.disabled;
      var mode = _props.mode;
      var defaultValue = _props.defaultValue;
      var droppable = _props.droppable;

      if (this.state.files.length === 0 && !_lodashCompat2.default.isEmpty(defaultValue)) {
        this.setState({ files: _lodashCompat2.default.cloneDeep(defaultValue) || [] });
      }
      if (!disabled && mode !== 'view' && droppable) {
        // 实现拖拽至 dropzone 上方时的显示效果
        var $dropzone = (0, _reactDom.findDOMNode)(this.refs.dropzone);

        // 需要避免被拖拽进入子元素时触发的 dragleave 干扰
        var first = false;
        var second = false;
        $dropzone.addEventListener('dragenter', function (e) {
          e.preventDefault(); // 阻止 dragover 否则 drop 不会触发
          e.stopPropagation();
          if (first) {
            second = true;
          } else {
            first = true;
            $dropzone.classList.add('dragover');
          }
        }, false);
        $dropzone.addEventListener('dragleave', function () {
          if (second) {
            second = false;
          } else if (first) {
            first = false;
          }
          if (!first && !second) {
            $dropzone.classList.remove('dragover');
          }
        }, false);

        $dropzone.addEventListener('dragover', function (e) {
          e.preventDefault(); // 阻止 dragover 否则 drop 不会触发
          e.stopPropagation();
          e.dataTransfer.dropEffect = 'copy';
        }, false);

        $dropzone.addEventListener('drop', function (e) {
          e.preventDefault();
          // 不要 stopPropagation，否则处理文件添加的监听函数无法被触发
          first = false;
          second = false;
          $dropzone.classList.remove('dragover');
        }, false);
      }
      // 用代码点击 input[type=file] 需要在一个非模拟的点击事件中才有效
      // 拦截触摸事件避免上传区域被 fastclick 等库处理
      var $inputArea = this.refs.inputArea || this.refs.dropzone;
      $inputArea && $inputArea.addEventListener('touchstart', function (e) {
        return e.stopPropagation();
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _state = this.state;
      var files = _state.files;
      var model = _state.model;
      var locale = _state.locale;

      if (files.length === 0 && !_lodashCompat2.default.isEmpty(nextProps.value)) {
        files = _lodashCompat2.default.cloneDeep(nextProps.value) || [];
      }
      if ('model' in nextProps) {
        model = Object.assign({}, MODEL, nextProps.model || {});
      }
      if ('locale' in nextProps) {
        locale = Object.assign({}, _zh_CN2.default, nextProps.locale || {});
      }
      this.setState({ model: model, files: files, locale: locale });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      for (var item in this.timeout) {
        clearTimeout(this.timeout[item]);
      }
    }
    /**
     * 上传文件
     * @param files 需要上传的文件
     * @private
     */


    /**
     * 上传成功响应事件
     * @param index 文件在files集合里的索引
     * @param res 成功信息 包括主键,下载链接,上传时间,上传人等.
     */


    /**
     * 上传失败响应事件
     * @param index 文件在files集合里的索引
     * @param res 失败信息
     */


    /**
     * 追加新选择的文件
     * @param newFiles 追加的文件
     */


    /**
     * 文件被选中后
     */


    /**
     * 响应点击上传文件按钮
     */


    /**
     * 删除某个文件
     * @param file 删除的文件
     */


    /**
     * 触发数据变更的回调函数 筛选所有有url的条目
     */


    /**
     * 监听拖拽过来的文件
     */


    // 渲染文件列表

    // 渲染拖拽区域

    // 渲染非拖拽上传区域

  }, {
    key: 'render',
    value: function render() {
      var _classNames2;

      var props = this.props;
      var prefixCls = props.prefixCls;
      var mode = props.mode;
      var size = props.size;
      var disabled = props.disabled;
      var droppable = props.droppable;
      var className = props.className;
      var emptyLabel = props.emptyLabel;
      var _state2 = this.state;
      var valid = _state2.valid;
      var files = _state2.files;
      var explain = _state2.explain;

      prefixCls += '-upload';
      if (mode === 'view') {
        var _classNames;

        var hasData = (files || []).length > 0;
        var _wrapperCls = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, '' + prefixCls, true), _defineProperty(_classNames, prefixCls + '-view', true), _defineProperty(_classNames, prefixCls + '-sm', size === 'small'), _defineProperty(_classNames, className, className), _defineProperty(_classNames, 'has-error', !valid), _classNames));
        return _react2.default.createElement(
          'div',
          { className: _wrapperCls },
          hasData ? this.renderFileList() : emptyLabel
        );
      }
      var wrapperCls = (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, '' + prefixCls, true), _defineProperty(_classNames2, prefixCls + '-sm', size === 'small'), _defineProperty(_classNames2, prefixCls + '-disbaled', disabled), _defineProperty(_classNames2, className, className), _defineProperty(_classNames2, 'has-error', !valid), _classNames2));
      return _react2.default.createElement(
        'div',
        { className: wrapperCls },
        this.renderFileList(),
        droppable ? this.renderDragInput() : this.renderFileInput(),
        !valid && _react2.default.createElement(
          'span',
          { className: 'has-explain ' + prefixCls + '-explain' },
          explain
        )
      );
    }

    /**
     * 校验有效性
     */


    /**
     * 重置控件，清空数据并清空校验状态
     */


    /**
     * 清空异常状态，校验提示等
     */


    /**
     * 获取当前所有已上传成功的有效的文件
     * @returns {Array}
     */

  }]);

  return Upload;
}(_react.Component), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  mode: _propTypes2.default.oneOf(['view', 'default']),
  multiple: _propTypes2.default.bool,
  droppable: _propTypes2.default.bool,
  value: _propTypes2.default.array,
  defaultValue: _propTypes2.default.array,
  locale: _propTypes2.default.shape({
    desc: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    uploading: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    uploadSucceed: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    uploadFailed: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    delete: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    overMaxSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    wrongType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    unknownDocumentType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    unknownImgType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    unknowArchiveType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    wrongExtType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    duplicated: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
  }),
  model: _propTypes2.default.shape({
    idField: _propTypes2.default.string,
    nameField: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
    urlField: _propTypes2.default.string,
    timeField: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
    oprField: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
  }),
  size: _propTypes2.default.oneOf(['small', 'default']),
  async: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  validation: _propTypes2.default.string,
  validator: _propTypes2.default.func,
  fileType: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.array]),
  fileMaxSize: _propTypes2.default.number,
  uploadParams: _propTypes2.default.object,
  headersConf: _propTypes2.default.object,
  errToast: _propTypes2.default.bool,
  useFormData: _propTypes2.default.bool,
  durationIfSucceed: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  emptyLabel: _propTypes2.default.string,
  onUpload: _propTypes2.default.func,
  onBeforeUploadAll: _propTypes2.default.func,
  onBeforeUpload: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onSuccess: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  domProps: _propTypes2.default.object
}, _class.defaultProps = {
  prefixCls: 'mt', // 样式前缀
  mode: 'default', // 控件的状态
  multiple: true, // 是否支持多文件
  droppable: false, // 是否支持拖拽上传
  value: [], // 初始显示的内容
  locale: {},
  model: {}, // 数据配置对象
  size: 'default', // 控件的大小
  async: true, // 是否支持异步上传
  disabled: false, // 是否禁用
  required: false, // 是否必填
  validation: '', // 校验失败时的提示
  validator: _data.noop, // 自定义校验
  fileType: null, // 支持的文件类型, 可选值为 `document` `image` `archive` `.ext1.ext2` 或传入方法
  fileMaxSize: Infinity, // 支持的最大文件大小, 单位为字节
  uploadParams: {}, // 会被原样传给 onUpload 的参数
  headersConf: {}, // 设置请求头
  errorToast: false, // 设置是否上传失败后立即弹窗报错而非抛出错误
  useFormData: true, // 是否使用 formData 来封装交互时上传的参数
  durationIfSucceed: 500, // 上传成功的文字显示的时间
  emptyLabel: '', // 只读时无值情况下显示的文本
  onUpload: _Helper.upload.bind(null, null), // 与服务端交互的函数, bind的第二个参数是上传路径
  onBeforeUploadAll: _data.noop, // 选择文件上传前的校验 返回false则终止上传
  onBeforeUpload: _data.noop, // 上传单个文件前的校验 返回false则终止上传
  onError: _data.noop, // 上传失败的回调
  onSuccess: _data.noop, // 上传成功的回调
  onChange: _data.noop, // 当值改变时触发的函数(包括删除/上传成功)
  onDelete: function onDelete() {
    return true;
  }, // 删除时触发的函数
  domProps: {} }, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this._uploadHandle = function (files) {
    var _props2 = _this2.props;
    var onUpload = _props2.onUpload;
    var uploadParams = _props2.uploadParams;
    var headersConf = _props2.headersConf;
    var _async = _props2.async;
    var disabeld = _props2.disabeld;
    var domProps = _props2.domProps;
    var useFormData = _props2.useFormData;
    var multiple = _props2.multiple;
    var errToast = _props2.errToast;

    _async = true; // TODO 同步上传
    if (disabeld || !files || files.length === 0) {
      return;
    }
    var model = _this2.state.model;
    // 需要上传的文件

    var filter = files.filter(function (file) {
      return (0, _Helper.isFileUploadable)(file);
    }).map(function (v) {
      var file = {
        _pkCode_: _lodashCompat2.default.uniqueId(),
        size: v.size,
        source: v
      };
      file[model.nameField] = v.name;
      return file;
    });
    if (_async) {
      // 异步上传
      filter.map(function (v) {
        v.uploading = true;
        return v;
      });
      _this2.setState({ files: multiple ? _this2.state.files.concat(filter) : filter }, function () {
        filter.forEach(function (file) {
          var index = _this2.state.files.findIndex(function (v) {
            return v._pkCode_ === file._pkCode_;
          });
          onUpload(file.source, uploadParams, { headers: headersConf, name: domProps.name, useFormData: useFormData, errToast: errToast }).then(_this2._successHandle.bind(_this2, index), _this2._errorHandle.bind(_this2, index));
        });
      });
    } else {}
  };

  this._successHandle = function (index, res) {
    var _props3 = _this2.props;
    var onSuccess = _props3.onSuccess;
    var durationIfSucceed = _props3.durationIfSucceed;
    var files = _this2.state.files;

    Object.assign(files[index], res, {
      uploading: false,
      succeed: true
    });
    _this2.forceUpdate();
    onSuccess(files[index], res);
    _this2._triggerChangeHandle();
    !_this2.timeout && (_this2.timeout = {});
    _this2.timeout[index] = setTimeout(function () {
      Object.assign(_this2.state.files[index], { // 之后再去掉上传成功的显示
        succeed: null
      });
      _this2.forceUpdate();
    }, durationIfSucceed);
    _this2.validate();
  };

  this._errorHandle = function (index, res) {
    var onError = _this2.props.onError;
    var files = _this2.state.files;

    Object.assign(files[index], {
      uploading: false,
      failed: true
    });
    _this2.forceUpdate();
    onError(files[index], res);
    _this2.validate();
    //Toaster.show({
    //  type: "error",
    //  title: (res && res.message) || "上传失败"
    //});
  };

  this._appendFilesHandle = function (newFiles) {
    return new Promise(function ($return, $error) {
      var explain, file, $iterator_file;
      var _props4 = this.props;
      var disabled = _props4.disabled;
      var multiple = _props4.multiple;
      var onBeforeUploadAll = _props4.onBeforeUploadAll;
      var locale = this.state.locale;

      if (disabled) {
        return $return();
      }
      var props = _extends({}, this.props);
      newFiles = Array.from(newFiles);

      function $IfStatement_3() {
        return $return();
      }

      if (newFiles && newFiles.length > 0) {
        if (!multiple) {
          newFiles = [newFiles[0]];
        }
        return Promise.resolve(onBeforeUploadAll(newFiles)).then(function ($await_8) {
          var res = $await_8;
          if (res === false || res && (0, _data.isString)(res)) {
            // 如果返回的是 false 或一个字符串,则报错; 返回 true 则继续走下面的验证逻辑
            _index.Toaster.error(res || "文件大小或类型不符合");
            return $return();
          }
          var filter = [];
          $iterator_file = [newFiles[Symbol.iterator]()];
          return Promise.resolve(function $ForStatement_1_loop($ForStatement_1_exit, $error) {
            var _this3 = this;

            function $ForStatement_1_next() {
              return $ForStatement_1_loop.$asyncbind(this)($ForStatement_1_exit, $error);
            }

            if (!($iterator_file[1] = $iterator_file[0].next()).done && ((file = $iterator_file[1].value) || true)) {
              var _ret = function () {
                var $IfStatement_5 = function $IfStatement_5() {
                  return void $ForStatement_1_next.call(this);
                };

                if ((0, _Helper.isDuplicated)(file, _this3.state.files)) {
                  return {
                    v: Promise.resolve(_index.Dialog.confirm({
                      title: '文件重复',
                      content: _util2.default.template(locale.duplicated, file)
                    })).then(function ($await_9) {
                      if ($await_9) {
                        filter.push(file);
                      }
                      return $IfStatement_5.call(_this3);
                    }.$asyncbind(_this3, $error), $error)
                  };
                } else {
                  explain = (0, _Helper.filterFiles)(file, Object.assign({}, props, { locale: _this3.state.locale }));

                  if (!_lodashCompat2.default.isEmpty(explain)) {
                    _index.Toaster.error(explain);
                  } else {
                    filter.push(file);
                  }
                  return {
                    v: $IfStatement_5.call(_this3)
                  };
                }
              }();

              if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
            } else return void $ForStatement_1_exit();
          }.$asyncbind(this)).then(function ($await_10) {
            ;
            this._uploadHandle(filter);
            return $IfStatement_3.call(this);
          }.$asyncbind(this, $error), $error);
        }.$asyncbind(this, $error), $error);
      }
      return $IfStatement_3.call(this);
    }.$asyncbind(_this2));
  };

  this._changeHandle = function (e) {
    return new Promise(function ($return, $error) {
      var files;
      files = (0, _reactDom.findDOMNode)(this.refs.fileinput).files;
      return Promise.resolve(new Promise(function ($return, $error) {
        var $logicalAnd_2;

        function $IfStatement_6() {
          return $return($logicalAnd_2);
        }

        if ($logicalAnd_2 = files) {
          return Promise.resolve(this._appendFilesHandle(files)).then(function ($await_11) {
            $logicalAnd_2 = $await_11;
            return $IfStatement_6.call(this);
          }.$asyncbind(this, $error), $error);
        }

        return $IfStatement_6.call(this);
      }.$asyncbind(this))).then(function ($await_12) {
        return $return();
      }.$asyncbind(this, $error), $error);
    }.$asyncbind(_this2));
  };

  this._clickHandle = function (e) {
    (0, _reactDom.findDOMNode)(_this2.refs.fileinput).click();
  };

  this._removeHandle = function (file, e) {
    return new Promise(function ($return, $error) {
      var files, index;

      e.preventDefault();
      return Promise.resolve(this.props.onDelete(file)).then(function ($await_13) {
        var res = $await_13;
        if (res) {
          files = this.state.files;
          index = files.indexOf(file);

          files.splice(index, 1);
          this.forceUpdate();
          this._triggerChangeHandle();
          this.validate();
        }
        return $return();
      }.$asyncbind(this, $error), $error);
    }.$asyncbind(_this2));
  };

  this._triggerChangeHandle = function () {
    _this2.props.onChange(_this2.getAllFiles());
  };

  this._dropHandle = function (e) {
    return new Promise(function ($return, $error) {
      function $IfStatement_7() {
        return $return();
      }

      if (e.dataTransfer.files) {
        return Promise.resolve(this._appendFilesHandle(e.dataTransfer.files)).then(function ($await_14) {
          return $IfStatement_7.call(this);
        }.$asyncbind(this, $error), $error);
      }
      return $IfStatement_7.call(this);
    }.$asyncbind(_this2));
  };

  this.renderFileList = function () {
    var _props5 = _this2.props;
    var prefixCls = _props5.prefixCls;
    var disabled = _props5.disabled;
    var mode = _props5.mode;
    var _state3 = _this2.state;
    var model = _state3.model;
    var locale = _state3.locale;
    var files = _state3.files;

    prefixCls += '-upload';
    return _react2.default.createElement(
      'ul',
      { className: prefixCls + '-items' },
      (files || []).map(function (file, index) {
        var _prefixCls = prefixCls + '-item';
        // TODO 如果failed 去支持重新上传
        var error = file.error;
        var uploading = file.uploading;
        var succeed = file.succeed;
        var failed = file.failed;
        var urlField = file[model.urlField];

        var timeField = (0, _data.isFunction)(model.timeField) ? model.timeField(file) : _util2.default.formatDatetime(file[model.timeField]);
        var oprField = (0, _data.isFunction)(model.oprField) ? model.oprField(file) : file[model.oprField];
        var nameField = (0, _data.isFunction)(model.nameField) ? model.nameField(file) : file[model.nameField];
        return _react2.default.createElement(
          'li',
          { className: '' + _prefixCls + (error ? ' ' + _prefixCls + '-error' : ''), key: index },
          _react2.default.createElement(
            'a',
            { href: urlField, target: '_blank' },
            _react2.default.createElement(
              'div',
              { className: _prefixCls + '-right' },
              uploading && _react2.default.createElement(
                'span',
                { className: _prefixCls + '-status ' + _prefixCls + '-status-loading' },
                locale.uploading
              ),
              succeed && _react2.default.createElement(
                'span',
                { className: _prefixCls + '-status ' + _prefixCls + '-status-success' },
                _react2.default.createElement('i', { className: _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-check' }),
                locale.uploadSucceed
              ),
              failed && _react2.default.createElement(
                'span',
                { className: _prefixCls + '-status ' + _prefixCls + '-status-failed' },
                _react2.default.createElement('i', { className: _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-cross' }),
                locale.uploadFailed
              ),
              _react2.default.createElement(
                'span',
                { className: _prefixCls + '-owner', title: (0, _react.isValidElement)(oprField) ? '' : oprField },
                oprField
              ),
              _react2.default.createElement(
                'span',
                { className: _prefixCls + '-time' },
                timeField
              ),
              mode !== "view" && !disabled && !file.readonly && _react2.default.createElement('i', { className: _prefixCls + '-remove ' + _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-cross',
                title: locale.delete,
                onClick: _this2._removeHandle.bind(_this2, file) })
            ),
            _react2.default.createElement(
              'div',
              { className: _prefixCls + '-name', title: (0, _react.isValidElement)(nameField) ? '' : nameField },
              nameField
            )
          )
        );
      })
    );
  };

  this.renderDragInput = function () {
    var _classNames3;

    var _props6 = _this2.props;
    var prefixCls = _props6.prefixCls;
    var disabled = _props6.disabled;
    var multiple = _props6.multiple;
    var domProps = _props6.domProps;
    var locale = _this2.state.locale;

    prefixCls += '-upload-dropzone';
    var outerCls = (0, _classnames2.default)((_classNames3 = {}, _defineProperty(_classNames3, prefixCls, true), _defineProperty(_classNames3, prefixCls + '-disabled', disabled), _classNames3));
    return _react2.default.createElement(
      'div',
      { ref: 'dropzone', className: outerCls, onDrop: !disabled && _this2._dropHandle, onClick: !disabled && _this2._clickHandle },
      _react2.default.createElement('input', _extends({}, domProps, { value: '', type: 'file', ref: 'fileinput', className: 'hidden', multiple: multiple, onChange: _this2._changeHandle })),
      _react2.default.createElement('i', { className: prefixCls + '-append ' + _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-plus' }),
      _react2.default.createElement(
        'div',
        { className: prefixCls + '-title' },
        locale.desc
      )
    );
  };

  this.renderFileInput = function () {
    var _classNames4;

    var _props7 = _this2.props;
    var prefixCls = _props7.prefixCls;
    var multiple = _props7.multiple;
    var disabled = _props7.disabled;
    var size = _props7.size;
    var locale = _this2.state.locale;

    prefixCls += '-upload-append';
    var outerCls = (0, _classnames2.default)((_classNames4 = {}, _defineProperty(_classNames4, prefixCls, true), _defineProperty(_classNames4, prefixCls + '-disabled', disabled), _classNames4));
    return _react2.default.createElement(
      'div',
      { ref: 'inputArea', className: outerCls, onClick: !disabled && _this2._clickHandle },
      _react2.default.createElement(
        'span',
        { className: prefixCls + '-desc' /*  */ },
        locale.desc
      ),
      _react2.default.createElement(
        _index.Button,
        { className: prefixCls + '-btn', disabled: disabled, size: size },
        _react2.default.createElement('input', { value: '', type: 'file', ref: 'fileinput', className: 'hidden', multiple: multiple, onChange: _this2._changeHandle, onClick: function onClick(e) {
            return e.stopPropagation();
          } }),
        locale.label
      )
    );
  };

  this.validate = function () {
    var _props8 = _this2.props;
    var mode = _props8.mode;
    var required = _props8.required;
    var validation = _props8.validation;
    var validator = _props8.validator;

    if (mode === 'view') {
      !_this2.state.valid && _this2.setState({ valid: true });
      return true;
    }
    var flag = true,
        files = _this2.state.files,
        explain = '';

    // 非空校验, 必须上传一条, 或者每一条都失败了
    if (required && ((files || []).length === 0 || files.every(function (v) {
      return v.failed;
    }))) {
      explain = validation || '';
      flag = false;
    }
    // 自定义校验
    if (validator) {
      //自定义校验
      if ((0, _data.isFunction)(validator)) {
        explain = validator(files);
      }
      //返回字符串 不为空表示校验没通过 且返回错误提示
      if (!(0, _data.isEmptyString)(explain)) {
        flag = false;
      } else {
        explain = '';
      }
    }
    _this2.state.explain = explain;
    _this2.state.valid = flag;
    _this2.forceUpdate();
    return flag;
  };

  this.reset = function () {
    if (_this2.props.mode !== "view") {
      (function () {
        var resetValue = _lodashCompat2.default.cloneDeep(_this2.props.defaultValue) || [];
        _this2.setState({ files: resetValue, valid: true, explain: "" }, function () {
          _this2.props.onChange(resetValue);
        });
      })();
    }
  };

  this.clear = function () {
    _this2.setState({ valid: true, explain: "" });
  };

  this.getAllFiles = function () {
    var _state4 = _this2.state;
    var model = _state4.model;
    var files = _state4.files;

    var keys = Object.values(model) || [];
    return (files || []).filter(function (v) {
      return v[model.urlField];
    }).map(function (v) {
      var file = {};
      keys.forEach(function (key) {
        return file[key] = v[key];
      });
      if ('readonly' in v) {
        file.readonly = v.readonly;
      }
      return file;
    });
  };
}, _temp);
exports.default = Upload;